import { useEffect } from 'react'

// Fires the auto-select callback once we know the user is parked on a follow-up branchpoint with a recommendation.
export const useDefaultPrimarySelection = (
  defaultPrimaryTargetId: string | null,
  onDefaultSelect?: (targetId: string) => void,
) => {
  useEffect(() => {
    if (!defaultPrimaryTargetId) return
    onDefaultSelect?.(defaultPrimaryTargetId)
  }, [defaultPrimaryTargetId, onDefaultSelect])
}
